"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Close(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M12.2928932,2.29289322 L13.7071068,3.70710678 L9.41389322,7.99989322 L13.7071068,12.2928932 L12.2928932,13.7071068 L7.99989322,9.41389322 L3.70710678,13.7071068 L2.29289322,12.2928932 L6.58589322,7.99989322 L2.29289322,3.70710678 L3.70710678,2.29289322 L7.99989322,6.58589322 L12.2928932,2.29289322 Z" })));
}
exports.default = Close;
//# sourceMappingURL=Close.js.map